import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['route', 'selectStationButton']

  changeRouteId () {
    const values = this.routeTargets.map((checkbox) => (checkbox.value)).join(',')
    this.selectStationButtonTarget.dataset.url = this.element.dataset.url + '?route_ids=' + values
  }
}
